import { useCallback, useMemo, useState } from 'react';
import { Calendar } from 'lucide-react';

const toISODate = (value) => {
  if (!value) return '';
  if (typeof value === 'string') {
    // Already an ISO-like string
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
    const d = new Date(value);
    if (!isNaN(d)) return d.toISOString().split('T')[0];
    return '';
  }
  if (value instanceof Date && !isNaN(value)) {
    return value.toISOString().split('T')[0];
  }
  return '';
};

const useMMARailFilters = ({ onFiltersChange, initialDate }) => {
  const [filters, setFilters] = useState({ date: toISODate(initialDate) });
  const [activeTab, setActiveTab] = useState('all');
  const [showDateSheet, setShowDateSheet] = useState(false);

  const filterObjects = useMemo(
    () => [
      {
        id: 'date',
        type: 'date',
        label: filters.date,
        icon: Calendar,
        hasDropdown: true,
        hasNonDefault: false
      }
    ],
    [filters.date]
  );

  const handleFilterClick = useCallback((id) => {
    if (id === 'date') setShowDateSheet(true);
  }, []);

  const updateFilter = useCallback(
    (id, value) => {
      setFilters((prev) => {
        const next = { ...prev, [id]: id === 'date' ? toISODate(value) : value };
        onFiltersChange?.(next);
        return next;
      });
    },
    [onFiltersChange]
  );

  const resetFilters = useCallback(() => {
    const next = { date: toISODate(initialDate) };
    setFilters(next);
    onFiltersChange?.(next);
  }, [initialDate, onFiltersChange]);

  return {
    filters,
    activeTab,
    filterObjects,
    handleTabChange: setActiveTab,
    handleFilterClick,
    updateFilter,
    resetFilters,
    showDateSheet,
    setShowDateSheet,
    hasActiveFilters: false
  };
};

export default useMMARailFilters;
